import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import Layout from "./layout";
import LayoutDashboard from "./layout/layout";
import Table from "components/table/table";
import { useEffect, useState } from "react";
import FormDinamic from "./cadEditDinamic";
import PerfilService from "../../services/PerfilService";
import { useNavigate } from "react-router-dom";

const Eventos = () => {
  const navigate = useNavigate();

  const [cadEditDinamic, setCadEditDinamic] = useState(false);
  const [user, setUser] = useState({} as any);

  const [dados, setDados] = useState(null);

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    await PerfilService.getUser()
      .then((response: any) => {
        setUser(response.data.user);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        //setLoading(false); // end loading
      });
  };

  const acao = (dados: any) => {
    setDados(dados);
    setCadEditDinamic(true);
  };

  const acaoCadastrar = () => {
    setDados(null);
    setCadEditDinamic(true);
  };

  const acaoCadastrado = (obj: any) => {
    setDados(null);
    setCadEditDinamic(false);
    setTimeout(() => {
      setCadEditDinamic(true);
      setDados(obj);
    }, 500);
  };

  return (
    <Layout user={user}>
      <LayoutDashboard>
        {!cadEditDinamic ? (
          <>
            <div className="flex-end">
              <ButtonPrimary
                className="md:col-span-2"
                type="button"
                onClick={() => navigate("/novo-evento")}
              >
                Novo Evento
              </ButtonPrimary>
            </div>
            <br />
            <div>
              <Table
                coluna1="Eventos"
                coluna2="Status"
                coluna3="Data"
                rota="/posts/my-events"
                acao={acao}
                tipo="evento"
              />
            </div>
          </>
        ) : (
          <FormDinamic
            nomeTela={"Evento"}
            tipoTela={4}
            acaoVoltar={setCadEditDinamic}
            dados={dados}
            acaoCadastrado={acaoCadastrado}
          />
        )}
      </LayoutDashboard>
    </Layout>
  );
};

export default Eventos;
